import { render, staticRenderFns } from "./TooltipBtn.vue?vue&type=template&id=127780ca"
import script from "./TooltipBtn.vue?vue&type=script&lang=js"
export * from "./TooltipBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports